import MentionElement from './mention-elem'

const SlateElement = ({ attributes, children, element }) => {
  const style = { textAlign: element.align }

  switch (element.type) {
    case 'table':
      return (
        <table>
          <tbody {...attributes}>{children}</tbody>
        </table>
      )
    case 'table-row':
      return <tr {...attributes}>{children}</tr>
    case 'image':
      return (
        <div>
          <img src={element.url} style={{ maxWidth: '100%' }} />
          {children}
        </div>
      )
    case 'table-cell':
      return <td {...attributes}>{children}</td>
    case 'block-quote':
      return <blockquote {...attributes}>{children}</blockquote>
    case 'bulleted-list':
      return <ul {...attributes}>{children}</ul>
    case 'heading-one':
      return <h1 {...attributes}>{children}</h1>
    case 'heading-two':
      return <h2 {...attributes}>{children}</h2>
    case 'list-item':
      return <li {...attributes}>{children}</li>
    case 'numbered-list':
      return (
        <ol {...attributes} type={1}>
          {children}
        </ol>
      )
    case 'mention':
      const props = { attributes, children, element }
      return <MentionElement {...props} />
    default:
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      )
  }
}

export default SlateElement
